/*                                     */
/**
 *
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/async/namespaces";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/**
 *
 *
 */
export const toggle = /*           */ asExport(o_util, "toggle", noop);
/**
 *
 *
 *
 *
 *
 */
export const get = /*           */ asExport(toggle, "get", noop);
/**
 *
 *
 *
 *
 */
export const getToggle = /*           */ asExport(toggle, "getToggle", noop);
